import { createServerFn } from "@tanstack/react-start";

import type { PublicSupabaseConfig } from "@/integrations/supabase/runtime-config";

/**
 * Returns the browser-safe Supabase configuration for the current environment.
 * Only the URL, the publishable key and the environment label leave the server —
 * never the service-role key, Google secrets or APP_USER_CONNECTION_KEY_SECRET.
 */
export const getPublicSupabaseConfig = createServerFn({ method: "GET" }).handler(
  async (): Promise<PublicSupabaseConfig | null> => {
    const { readPublicSupabaseConfig } = await import("@/integrations/supabase/runtime-config");
    const config = readPublicSupabaseConfig();
    if (!config) return null;
    return { url: config.url, publishableKey: config.publishableKey, source: config.source };
  },
);
